<div class="modals waiting-goods" [class.modals-show]="isModalReceiptsShow" [class.modals-hide]="!isModalReceiptsShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4>Надходження нових товарів</h4>
  <ul class="last-receipts">
    <ng-container *ngIf="receiptsList.length > 0">
      <li (click)="goToReceiptData(receipt.datasort)" *ngFor="let receipt of receiptsList">
        <a>Надходження товарів від {{ receipt.data }}</a>
      </li>
    </ng-container>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
